// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyD7kq7prb5C2uM-luNGB5t_3ZEu6sJcRaM",
    authDomain: "mathpicsolver.firebaseapp.com",
    projectId: "mathpicsolver",
    storageBucket: "mathpicsolver.firebasestorage.app",
    messagingSenderId: "433559130444",
    appId: "1:433559130444:web:246ded72ce19207bb57fe9",
    measurementId: "G-BN8WDTFM4E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics, firebaseConfig };
